import { useState,useEffect } from '@wordpress/element';
import { MdLockOutline } from "react-icons/md";
import { __ } from '@wordpress/i18n';
import { BiCertification } from "react-icons/bi";
import { VscDebugRestart } from "react-icons/vsc";
import { RxWidth, RxPadding, RxSpaceBetweenHorizontally} from "react-icons/rx";
import { Spinner,ToggleControl } from '@wordpress/components';
import { VerifyKey } from '../../vayu-sites/template/verifykey';
import Sidebar from './sidebar';
import App from '../../vayu-sites/App';
import {
    ContainerIcon,
    ButtonIcon,
    HeadingIcon,
    SpacerIcon,
    ProductIcon,
    PostGridIcon,
    SliderIcon,
    FlipBoxIcon,
    ImageIcon,
    VideoIcon,
    LottieIcon,
    FaqIcon,
    TableOfContentsIcon,
    IconBlockIcon,
    TimelineIcon,
    MegaMenuIcon,
    QueryLoopIcon,
    ImageHotspotIcon,
    BlurbIcon,
    UnfoldIcon,
    PostPaginationIcon,
} from './blockIcons';

const ToggleSwitch = ({ initialValue, onChange, proStatus, verifyLicense }) => {
    const [isChecked, setIsChecked] = useState(initialValue);

    const handleChange = () => {
        const newValue = !isChecked;
        setIsChecked(newValue);
        onChange(newValue); // Callback to parent component
    };
    if (!proStatus || (proStatus && verifyLicense)) {
        return (
            <label className="toggle-switch new-toggle">
                <input type="checkbox" checked={isChecked} onChange={handleChange} />
                <span className="slider round"></span>
            </label>
        );
    } else {
        return (
            <label className="toggle-switch">
                <MdLockOutline />
                <span className="pro">{'pro'}</span>
            </label>
        );
    }
};

function MainContent({ activeTab, setActiveTab }) {

    const [navTab, setNavTab] = useState(1);
    const [isLoading, setLoading] = useState(false);
    const [checkedValue, setCheckedValue] = useState({});


    // let vayuProStatus = '';
    // if(vayublock.vayuProStatus == 'activated'){
    //     vayuProStatus = 'vayu-pro-active';
    // }
    // else{
    //     vayuProStatus = ''; 
    // }
    
    const NavTabClick = (tabNumber) => {
        setNavTab(tabNumber);
    };    


    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'blocks') {
            const newUrl = `${window.location.pathname}?page=vayu-blocks-settings`;
            window.history.pushState(null, null, newUrl);
        }else{
            const newUrl = `${window.location.pathname}?page=vayu-blocks`;
            window.history.pushState(null, null, newUrl);
        }
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const pathParam = searchParams.get('path');
        if (pathParam === 'blocks') {
            setActiveTab('blocks');
        }
    }, []);
   

    // Toggle Switch
    const [toggleSwitches, setToggleSwitches] = useState(vayublock.options);
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [globalData, setGlobalData] = useState({containerWidth:vayublock.options.global.containerWidth,
                                                containerGap:vayublock.options.global.containerGap,
                                                containerPadding:vayublock.options.global.containerPadding,
                                                autoRecovery: vayublock?.options?.global?.autoRecovery,
                                                });
    useEffect(() => {
        const newData = { ...toggleSwitches }; // Copy the object
        delete newData['global']; // Remove the key
        setToggleSwitches(newData); // Update state with the new object
    }, []);

    // ajax data update
    const optionPanel = (blockData) => {
        return fetch(vayublock.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'vayu_blocks_option_panel',
                security: vayublock.nonce,
                inputData: JSON.stringify(blockData),
            }),
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
            setLoading(false);
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
            throw error;
        });
    };

    // addons on/off data update
    const handleToggleSwitchChange = (key, newValue) => {
        setLoading(key);
        optionPanel({type:'addons',key:key,value:newValue});
    }

    // global data change
    const handleGlobalDataChange = (e) => {
        const { name, value } = e.target;
        setGlobalData({ ...globalData, [name]: value });
        setBtnDisabled(false);
    }

    // global data update
    const handleToggleSwitchClick = () => {
        setLoading(true);
        setBtnDisabled(true);
        optionPanel({type:'global',key:'global',value:globalData} );
    }

    // get all addons data
    function getDescription(key,value='') {
            switch (key) {
                case 'container':
                    return {
                        value: value ===''? vayublock.options.container.isActive:value,
                        icon: <ContainerIcon />,
                        description: __('A versatile block to organize multiple elements in a single layout.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#container'
                    };
                case 'button':
                    return {
                        value: vayublock.options.button.isActive,
                        icon: <ButtonIcon />,
                        description: __('A block to create interactive and visually appealing call-to-action buttons.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#btn'
                    };
                case 'product':
                    return {
                        value: vayublock.options.product.isActive,
                        icon: <ProductIcon />,
                        description: __('This enables you to seamlessly integrate your WooCommerce products into your content, in posts or pages.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#woocommerce-product'
                    };
                case 'heading':
                    return {
                        value: vayublock.options.heading.isActive,
                        icon: <HeadingIcon />,
                        description: __('A block to add styled headings for better content hierarchy with dynamic content.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#advance-headings'
                    };
                case 'spacer':
                    return {
                        value: vayublock.options.spacer.isActive,
                        icon: <SpacerIcon />,
                        description: __('A block to add customizable space between other blocks.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#spacer'
                    };

                    case 'productFilter':
                    return {
                        value: '',
                        icon: <ProductIcon />,
                        description: __('Product filter Easily design attractive buttons with Vayu Blocks advanced customizations.', 'vayu-blocks'),
                        link1: '#',
                        link2: '#'
                    };
                    case 'postgrid':
                    return {
                        value: vayublock.options.postgrid.isActive,
                        icon: <PostGridIcon />,
                        description: __('A block to display blog posts in an organized grid layout.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#post-grid'
                    };

                    case 'advanceSlider':
                    return {
                        value: vayublock.options.advanceSlider.isActive,
                        icon: <SliderIcon />,
                        description: __('A block to showcase images or content in a sliding carousel.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#slider'
                    };

                    case 'flipBox':
                    return {
                        value: vayublock.options.flipBox.isActive,
                        icon: <FlipBoxIcon />,
                        description: __('A block to display content that flips on hover for an engaging effect.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#flip-box'
                    };

                    case 'image':
                    return {
                        value: vayublock.options.image.isActive,
                        icon: <ImageIcon />,
                        description: __('A block to add and customize pictures in your content.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#image'
                    };

                    case 'lottie':
                    return {
                        value: vayublock.options.lottie.isActive,
                        icon: <LottieIcon />,   // image-based from blockIcons.js
                        description: __('A block to add and customize lottie animation in your content.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#lottie'
                    };

                    case 'faq':
                    return {
                        value: vayublock.options.faq.isActive,
                        icon: <FaqIcon />,
                        description: __('Add accordions/FAQ schema to your page.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#faq'
                    };

                    case 'tableOfContents':
                    return {
                        value: vayublock.options.tableOfContents.isActive,
                        icon: <TableOfContentsIcon />,
                        description: __('Add a table of contents to allow page navigation.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#table-of-contents'
                    }; 

                    case 'video':
                    return {
                        value: vayublock.options.video.isActive,
                        icon: <VideoIcon />,
                        description: __(' A block to embed and display videos from various sources, like Media, and YouTube, directly on your website.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#video'
                    };

                    case 'icon':
                        return {
                            value: vayublock.options.icon.isActive,
                            icon: <IconBlockIcon />,
                            description: __('A block to insert icons for visual enhancement and branding.', 'vayu-blocks'),
                            link1: '#',
                            link2: 'https://themehunk.com/docs/vayu-blocks/#icon'
                        };

                    case 'advanceTimeline':
                        return {
                            value: vayublock.options.advanceTimeline.isActive,
                            icon: <TimelineIcon />,
                            description: __('A block to showcase events or milestones in chronological order.', 'vayu-blocks'),
                            link1: '#',
                            link2: 'https://themehunk.com/docs/vayu-blocks/#timeline'
                        };

                    case 'megaMenu':
                    return {
                        value: vayublock.options.imageFlip.isActive,
                        icon: <MegaMenuIcon />,
                        description: __('', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/'
                    };

                    case 'advanceQueryLoop':
                    return {
                        value: vayublock.options.advanceQueryLoop.isActive,
                        icon: <QueryLoopIcon />,
                        description: __('A block to display posts with advanced filtering options.', 'vayu-blocks'),
                        link1: '#',
                        link2: 'https://themehunk.com/docs/vayu-blocks/#aqb'
                    };

                    case 'imageHotspot':
                        return {
                            value: vayublock.options.imageHotspot.isActive,
                            icon: <ImageHotspotIcon />,
                            description: __('A block to highlight specific parts of an image using pins.', 'vayu-blocks'),
                            link1: '#',
                            link2: 'https://themehunk.com/docs/vayu-blocks/#image-pointer'
                        };

                        case 'blurb':
                            return {
                                value: vayublock.options.blurb.isActive,
                                icon: <BlurbIcon />,
                                description: __('A block to highlight specific parts of an image using pins.', 'vayu-blocks'),
                                link1: '#',
                                link2: 'https://themehunk.com/docs/vayu-blocks/#image-pointer'
                            };

                case 'unfold':
                        return {
                            value: vayublock.options.unfold.isActive,
                            icon: <UnfoldIcon />,
                            description: __('A block to highlight specific parts of an image using pins.', 'vayu-blocks'),
                            link1: '#',
                            link2: 'https://themehunk.com/docs/vayu-blocks/#image-pointer'
                        };
                
                case 'postPagination':
                        return {
                            value: vayublock.options.postPagination.isActive,
                            icon: <PostPaginationIcon />,
                            description: __('A block to insert pagination in post', 'vayu-blocks'),
                            link1: '#',
                            link2: 'https://themehunk.com/docs/vayu-blocks/#post-pagination'
                        };


                default:
                    return '';
            }
    }

    // Upgrade 
    const verifyKeyCheck = VerifyKey();

    return (
        <div className="th-content">
            <div className="th-conatiner">
                {activeTab === 'welcome' && (
                    <div className="th-content-wrap th-welcome">
                        <div className="th-main">
                            <div className="th-main-wrap">
                                <h2>{__('Welcome to Vayu Blocks', 'vayu-blocks')}</h2>
                                <p>{__('Enhance your Block Editor with custom Vayu Blocks, crafting dynamic, visually appealing content layouts for a seamless and beautiful user experience.', 'vayu-blocks')}</p>
                            </div>

                            <div className="th-blocks-statusbar">
                                <span className="th-active-count">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-5"/></svg>
                                    {Object.values(toggleSwitches).filter(v => v.isActive).length}
                                    {__(' of ', 'vayu-blocks')}
                                    {Object.keys(toggleSwitches).length}
                                    {__(' blocks active', 'vayu-blocks')}
                                </span>
                                <span className="th-autosaved">{__('Changes autosaved', 'vayu-blocks')}</span>
                            </div>

                            <div className={`sw-wrapprer`}>

                                {Object.entries(toggleSwitches).map(([key, value]) => (
                                    <div className={`sw-box ${key}`} key={key}>
                                        <div className='th-sw-right'>
                                            <div>
                                            <label className='block-label'>{getDescription(key).icon}{key}</label>
                                            {/* <ToggleSwitch initialValue={getDescription(key).value} onChange={newValue => handleToggleSwitchChange(key, newValue)} proStatus={value.pro} verifyLicense={verifyKeyCheck} /> */}
                                            {isLoading===key ? (
                                            <span className="th-toggle-loader">
                                                <Spinner/>
                                            </span>
                                            ) :<ToggleControl
                                            __nextHasNoMarginBottom
                                            checked={value.isActive}
                                            onChange={(newValue) => {
                                                setToggleSwitches(prev => ({
                                                ...prev,
                                                [key]: {isActive: newValue}
                                            }));
                                            handleToggleSwitchChange(key, newValue);
                                            }}
                                            // disabled={isLoading===key? true : false}
                                            />}

                                            {/* {isLoading===key ? (<Spinner/>) : (<ToggleSwitch onChange={(newValue) => handleToggleSwitchChange(key, newValue)}   verifyLicense={verifyKeyCheck} initialValue={getDescription(key).value}  />)} */}

                                            </div>
                                        </div>
                                        <div className='th-sw-bottom'>
                                            <p>{getDescription(key).description}</p>
                                            {/* <a href={getDescription(key).link1} target="_blank">{__( 'View', 'vayu-blocks' )}</a> */}
                                            <a href={getDescription(key).link2} target="_blank">{__( 'Documentation', 'vayu-blocks' )}</a>
                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div> {/* Welcome Data Close  */}

                {/* Welcome page sidebar  */}
                    <Sidebar />
                    </div>
                )}

                {/* Setting Page  */}
                {activeTab === 'blocks' && (
                    <div className="th-content-wrap th-block th-settings">
                        <div className="th-main">
                            <aside>
                                <nav>
                                <a href="#" className={navTab === 1 ? 'selected' : ''} onClick={() => NavTabClick(1)}><BiCertification />{__('Editor Options','vayu-blocks')}</a>

                                <a href="#" className={navTab === 2 ? 'selected' : ''} onClick={() => NavTabClick(2)}><VscDebugRestart />{__('Recovery','vayu-blocks')}</a>
                                {/* <a href="#" className={navTab === 2 ? 'selected' : ''} onClick={() => NavTabClick(2)}><BiCoinStack />{__('Assets','vayu-blocks')}</a> */}
                                </nav>
                            </aside>
                            <div className="content-wrapper">
                                {navTab === 1 && (
                                <div>
                                    {/* Content for Tab 1 */}
                                    <h2 className='wrapper-title'>{__('Editor Options','vayu-blocks')}</h2>
                                    <div className='option-wrapper'>
                                        <RxWidth /><p>{__('Container Width', 'vayu-blocks')} </p>
                                        <input
                                            type='number'
                                            id="maxwidth"
                                            name="containerWidth"
                                            min="1"
                                            max="2100"
                                            value={globalData.containerWidth}
                                            onChange={handleGlobalDataChange}
                                        />
                                    <span className='unit'>{__('px','vayu-blocks')}</span>
                                    </div>

                                    <div className='option-wrapper'>
                                    <RxPadding /><p>{__('Padding', 'vayu-blocks')}</p>
                                        <input
                                            type='number'
                                            id="padding"
                                            name="containerPadding"
                                            min="1"
                                            max="1600"
                                            value={globalData.containerPadding}
                                            onChange={handleGlobalDataChange}
                                        />
                                        <span className='unit'>{__('px','vayu-blocks')}</span>
                                    </div>

                                    <div className='option-wrapper'>
                                    <RxSpaceBetweenHorizontally /><p>{__('Container Gap', 'vayu-blocks')} </p>
                                        <input
                                            type='number'
                                            id="maxwidth"
                                            name="containerGap"
                                            min="1"
                                            max="2100"
                                            value={globalData.containerGap}
                                            onChange={handleGlobalDataChange}
                                        />
                                        <span className='unit'>{__('px','vayu-blocks')}</span>
                                    </div>

                                    <div className='option-submit'>
                                        <button  onClick={()=>handleToggleSwitchClick(globalData)} disabled = {btnDisabled && 'disabled'}>  {/*onClick={handleSave} */}
                                        {isLoading ? <Spinner style={{ height: 'calc(4px * 3)',width: 'calc(4px * 3)'}}/> : __('Save', 'vayu-blocks')}

                                        
                                        </button>
                                    </div>

                                </div>
                                )}

                                {navTab === 2 && (
                                    <div>

                                    <h2 className='wrapper-title'>{__('Recover Options','vayu-blocks')}</h2>

                                    <div className="option-wrapper">
                                        <VscDebugRestart /><p >{__('Auto Recovery','vayu-blocks')}</p>
                                        <label className="vb-toggle-switch-recovery">
                                            <input
                                                type="checkbox"
                                                name="autoRecovery"
                                                checked={globalData.autoRecovery}
                                                onChange={(e) =>
                                                    handleGlobalDataChange({
                                                        target: {
                                                            name: 'autoRecovery',
                                                            value: e.target.checked, // true or false
                                                        },
                                                    })
                                                }
                                            />
                                            <span className="vb-toggle-slider"></span>
                                        </label>
                                    </div>

                                    <div className='option-submit'>
                                        <button  onClick={()=>handleToggleSwitchClick(globalData)} disabled = {btnDisabled && 'disabled'}>  {/*onClick={handleSave} */}
                                        {isLoading ? <Spinner style={{ height: 'calc(4px * 3)',width: 'calc(4px * 3)'}}/> : __('Save', 'vayu-blocks')}

                                        
                                        </button>
                                    </div>

                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'sites' && <App/> }
            </div>    
        </div>
    );
}

export default MainContent;